// extracted by mini-css-extract-plugin
export var externalLink = "_be-0";
export var internalLinkLabel = "_be-1";